export default __webpack_public_path__ + "static/media/abu-dhabi.59c7d6c9.jpg";